import { fileTypeFromBlob } from "file-type";

import { axiosClient } from "@api/clients";

import type { AxiosProgressEvent, CancelToken } from "axios";

import type { IApiResponse } from "@api";
import type { IStartUploadResponse } from "@api/files/types";
import type { IFileResponse } from "@interfaces";

const startUpload = async (
  file: File,
): Promise<IApiResponse<IStartUploadResponse>> => {
  const fileType = await fileTypeFromBlob(file);

  return axiosClient.post("/files/upload/start/", {
    file_name: file.name,
    file_mime_type: fileType?.mime || file.type,
  });
};

export const postFile = async (
  file: File,
  progressCallBack?: (progressEvent: AxiosProgressEvent) => void,
  cancelToken?: CancelToken,
): Promise<IApiResponse<IFileResponse>> => {
  const fileType = await fileTypeFromBlob(file);
  const data = new FormData();
  const startUploadData = await startUpload(file);

  data.append(
    "AWSAccessKeyId",
    startUploadData?.data?.fields?.AWSAccessKeyID?.toString(),
  );
  data.append(
    "signature",
    startUploadData?.data?.fields?.signature?.toString(),
  );
  data.append("key", startUploadData?.data?.fields?.key?.toString());
  data.append("Content-Type", fileType?.mime || file.type);
  data.append("policy", startUploadData?.data?.fields?.policy?.toString());
  data.append("file", file);

  await axiosClient.post(startUploadData?.data?.presign_url, data, {
    onUploadProgress(progressEvent) {
      progressCallBack?.(progressEvent);
    },
    cancelToken,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return axiosClient.post("/files/upload/finish/", {
    file_id: startUploadData?.data?.id,
  });
};

export const files = {
  postFile,
};
